import { render, staticRenderFns } from "./MyButton.vue?vue&type=template&id=7f390e19&scoped=true&"
import script from "./MyButton.vue?vue&type=script&lang=js&"
export * from "./MyButton.vue?vue&type=script&lang=js&"
import style0 from "./MyButton.vue?vue&type=style&index=0&id=7f390e19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f390e19",
  null
  
)

export default component.exports